var React = require('react');

function Process (props) {
    return React.createElement("svg",props,[React.createElement("title",{"id":"afterpay_info_modal-instant-approval-icon-title","key":0},"Instant Approval Icon"),React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#222","key":1},[React.createElement("path",{"d":"M21.5 30.5l-7-15-12 6.5 6.426 15.819a1 1 0 0 1 .074.376V64h37l12-7V31.5l6.5-15-13 5.5L46 37.5H10.5l11-7z","strokeWidth":"1.4","strokeLinecap":"square","key":0}),React.createElement("path",{"strokeWidth":"1.4","strokeLinecap":"square","d":"M48 30.5H21.482v7M58 31l-12 6.5v26","key":1}),React.createElement("path",{"d":"M26 18l-5.87-4.868M44 19l6-4-6 4zM29.861 12.897L25.14 7.103M40 14l5-6-5 6zM35.333 11.889V4.11","strokeWidth":".9","key":2})])]);
}

Process.defaultProps = {"className":"i-afterpay-process-icon","width":"70","height":"70","viewBox":"0 0 70 70","aria-labelledby":"afterpay_info_modal-instant-approval-icon-title"};

module.exports = Process;

Process.default = Process;
